import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Tooltip title="Go Back">
      <IconButton 
        onClick={handleGoBack} 
        color="primary" 
        size="medium"
        sx={{ 
          bgcolor: '#ffffff',
          color: 'primary.main',
          border: '1px solid #e2e8f0',
          '&:hover': {
            bgcolor: 'primary.main',
            color: '#ffffff',
            borderColor: 'primary.main',
            transform: 'translateX(-2px)',
          },
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          borderRadius: 2.5,
          transition: 'all 0.2s ease',
          p: 1,
          mb: 2,
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;